import { forwardRef } from 'react';
import { Popover, type PopoverProps } from 'react-aria-components';
import { cn } from './utils';

export interface AgPopoverProps extends PopoverProps {
  children: React.ReactNode;
}

export const AgPopover = forwardRef<HTMLDivElement, AgPopoverProps>(({ children, className, ...props }, ref) => {
  return (
    <Popover
      ref={ref}
      className={cn(
        'min-w-[var(--trigger-width)] overflow-hidden rounded-md bg-white border border-neutral-5 shadow-sm outline-none',
        'entering:animate-in entering:fade-in-0 entering:zoom-in-95',
        'exiting:animate-out exiting:fade-out-0 exiting:zoom-out-95',
        className
      )}
      {...props}
    >
      {children}
    </Popover>
  );
});

AgPopover.displayName = 'AgPopover';
